// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AlertIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import useIntl from '../../../../../hooks/useIntl';
import generalMessages from '../../../../App/messages';
import messages from './messages';

type Props = {
  open: boolean,
  count: number,
  onContinue: () => void,
  onCancel: () => void,
};

function ApplicationsNeedingInfoModal({
  open,
  count,
  onContinue,
  onCancel,
}: Props) {
  const intl = useIntl();

  return (
    <Modal
      open={open}
      onClose={onCancel}
      status="warning"
      icon={<AlertIcon />}
      title={intl.formatMessage(messages.title, { count })}
      actions={
        <>
          <Button variant="text" onClick={onCancel}>
            <FormattedMessage {...generalMessages.cancel} />
          </Button>
          <Button variant="primary" onClick={onContinue}>
            <FormattedMessage {...messages.continue} />
          </Button>
        </>
      }
    >
      <Stack spacing={2}>
        <Typography variant="bodyMedium">
          <FormattedMessage {...messages.intro} values={{ count }} />
        </Typography>
        <Typography variant="bodyMedium">
          <FormattedMessage {...messages.optionsIntro} />
        </Typography>
        <Stack spacing={0.5}>
          <Typography variant="labelLarge">
            <FormattedMessage {...messages.updateYourselfTitle} />
          </Typography>
          <Typography variant="bodyMedium">
            <FormattedMessage {...messages.updateYourselfBody} />
          </Typography>
        </Stack>
        <Stack spacing={0.5}>
          <Typography variant="labelLarge">
            <FormattedMessage {...messages.askFortressTitle} />
          </Typography>
          <Typography variant="bodyMedium">
            <FormattedMessage {...messages.askFortressBody} />
          </Typography>
        </Stack>
        <Typography variant="bodyMedium">
          <FormattedMessage {...messages.outro} values={{ count }} />
        </Typography>
      </Stack>
    </Modal>
  );
}

export default ApplicationsNeedingInfoModal;
